import { LICENSE_CONCLUDED } from '../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../helpers/features';
import { useOrganizationGeneralSettings } from '../api/organization';

/**
 * Hook to check if the license concluded feature is enabled for the organization.
 * Uses React Query for automatic caching and request deduplication.
 */
const useIsLicenseConcludedEnabled = (organizationId: number) => {
  const isFeatureFlagEnabled = useIsFeatureEnabled(LICENSE_CONCLUDED);
  const { data: settings, isLoading } = useOrganizationGeneralSettings(organizationId, isFeatureFlagEnabled);

  if (isLoading) {
    return false;
  }

  const isSettingEnabled = settings?.licenseConcludedEnabled ?? false;

  return isFeatureFlagEnabled && isSettingEnabled;
};

export default useIsLicenseConcludedEnabled;
